import {DatePicker, LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';
import {csCZ} from '@mui/x-date-pickers/locales';
import {TextField} from '@mui/material';

import moment from 'moment';
import 'moment/dist/locale/cs';

export const UiDatePicker = (props: {
    value: any,
    onChange: (value) => void,
    label: string,
    forbidWeekends?: true,
}) => {
    return <LocalizationProvider
        dateAdapter={AdapterMoment}
        adapterLocale="cs"
        localeText={csCZ.components.MuiLocalizationProvider.defaultProps.localeText}
    >
        <DatePicker
            value={moment(props.value)}
            onChange={(value) => props.onChange(value)}
            label={props.label}
            showDaysOutsideCurrentMonth
            className={cmpClass}
            slots={{
                textField: CustomTextInput,
            }}
            slotProps={{
                popper: {
                    placement: 'bottom',
                },
                actionBar: {
                    actions: ['today', 'cancel'],
                },
            }}
            shouldDisableDate={(date: moment.Moment) => {
                return date.day() === 0 || date.day() === 6;
            }}
        />
    </LocalizationProvider>;
};

const cmpClass = 'ui-week-picker';

const CustomTextInput = (props: any) => {
    const date = moment(props.value, 'DD.MM.YYYY').toDate();

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    const weekday = new Intl.DateTimeFormat('cs-CZ', {weekday: 'long'}).format(date);

    const value = `${day}.${month}.${year} - ${weekday.charAt(0).toUpperCase() + weekday.slice(1)}`;

    return <TextField
        {...props}
        value={value}
        fullWidth
    />;
};
